import styled from 'styled-components';

export const Wrapper = styled.section`
  background-color: #fff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  padding: 15px;
  display: flex;
  margin: 1rem;
  align-items: center;
  flex-direction: column;
`;

export const ShowDesc = styled.div`
  display: flex;
  flex-direction: column;
  padding: 9px;
  max-height: 23rem;
`;

export const imageEpisode = styled.img`
  max-width: 100%;
  max-height: 28rem;
  box-shadow: 0px 15px 20px rgba(0.25, 0.25, 0.25, 0.25);
  border-radius: 4px;
`;

export const DivCentral = styled.div`
  line-height: 10rem;
`;
